import styled from 'styled-components';

import { Flex, token } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
  border-top: 1px solid ${token('colors.gray300')};
`;
